/**
 * @file index
 */
import { Select as InnerSelect } from './Select';
import { Option } from './Option';
import { SelectContainer } from './SelectContainer';
export var Select = Object.assign(InnerSelect, {
  Option: Option,
  Container: SelectContainer
});